import { TFunction } from 'i18next';

import { CalendarType } from './EditCalendarItem/CalendarRow';
import { MainCalendarInfo } from './EditCalendarItem/useUpdateCalendars';

type GetCalendarItemStatusProps = {
  t: TFunction;
  accountCalendars: CalendarType[];
  mainCalendarInfo: MainCalendarInfo;
  profileId: string;
};

export const getCalendarItemStatus = ({
  t,
  accountCalendars,
  mainCalendarInfo,
  profileId,
}: GetCalendarItemStatusProps) => {
  const isSynced = accountCalendars.some(({ parentId, isSynced }) => parentId === profileId && isSynced);
  const isPrimary = mainCalendarInfo.id === profileId;
  const status = [(isSynced && t('synced')) || t('added_not_synced'), isPrimary && t('primary')]
    .filter(Boolean)
    .join(', ');

  return { status, isPrimary };
};
